import { Select } from '@bloomfieldrobotics/canopy';
import { UnitsEnum } from '../../../../services/entities/impl/blfApi/apiConstants';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
const unitsDisplayDict: Record<UnitsEnum, string> = {
  [UnitsEnum.metric]: 'Metric',
  [UnitsEnum.imperial]: 'Imperial',
};

type Props = {
  value: UnitsEnum;
  onChange: (units: UnitsEnum) => void;
};

const UnitSelectionDropdown = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  const unitOptions = Object.values(UnitsEnum).map((unit) => ({
    label: t(unitsDisplayDict[unit]),
    value: unit,
  }));

  return (
    <Select
      options={unitOptions}
      value={value}
      onChange={onChange}
      menuAlignment='right'
    />
  );
};

export default UnitSelectionDropdown;
